export default "__VITE_ASSET__8f09d0b4__"